var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.99999C12.103 4.99999 13 5.89699 13 7.99999H15C15 4.77499 13.225 2.99999 10 2.99999V4.99999ZM13.422 10.443C13.2299 10.2683 12.9774 10.1752 12.7178 10.1832C12.4583 10.1912 12.212 10.2998 12.031 10.486L9.63804 12.947C9.06204 12.837 7.90404 12.476 6.71204 11.287C5.52004 10.094 5.15904 8.93299 5.05204 8.361L7.51104 5.96699C7.69745 5.78612 7.80617 5.53982 7.8142 5.2802C7.82223 5.02059 7.72892 4.76804 7.55404 4.57599L3.85904 0.512995C3.68408 0.320352 3.44092 0.203499 3.18119 0.187255C2.92146 0.17101 2.66564 0.256653 2.46804 0.425995L0.298038 2.28699C0.125149 2.46051 0.0219574 2.69145 0.00803782 2.93599C-0.00696218 3.18599 -0.292962 9.108 4.29904 13.702C8.30504 17.707 13.323 18 14.705 18C14.907 18 15.031 17.994 15.064 17.992C15.3086 17.9783 15.5394 17.8747 15.712 17.701L17.572 15.53C17.7415 15.3325 17.8273 15.0768 17.8113 14.817C17.7952 14.5573 17.6785 14.3141 17.486 14.139L13.422 10.443Z",
    fill: "#ffffff "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cb90a24b7b17e1aa9ddee2bdfc8df5ae.svg";
export { ForwardRef as ReactComponent };